// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ExecutedBurn } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Model/Burn';
import { TemplateHistory, useTemplateHistory } from '../../useTemplateHistory';

export const useExecutedBurns2Step = (): TemplateHistory<ExecutedBurn> =>
  useTemplateHistory(ExecutedBurn);
